import { ClientIntakePage } from '../client-intake';
import { ClientPortalLayout } from './components/ClientPortalLayout';
import { usePortalSubject } from '../../contexts/PortalSubjectContext';

export function ClientPortalIntakePage(): JSX.Element {
  const { activePatientId } = usePortalSubject();
  return (
    <ClientPortalLayout
      title="Client intake"
      description="Complete intake and onboarding forms. You can save progress and return later."
      fullBleed
    >
      <ClientIntakePage billingPatientId={activePatientId} />
    </ClientPortalLayout>
  );
}

